export const FILTERS_UPDATE = 'FILTERS_UPDATE';
export const FILTERS_CLEAR = 'FILTERS_CLEAR';
export const FILTERS_SET = 'FILTERS_SET';
export const FILTERS_CLEAR_FIELDS = 'FILTERS_CLEAR_FIELDS';
